// src/services/authService.js

import axios from 'axios';
import { API_URL } from '@/globals/contants';
import apiClient from "@/api/axios";

// Crear una instancia de Axios con la configuración base
const apiClientU = axios.create({
    baseURL: API_URL, // URL base de tu API
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Iniciar sesión del usuario.
 * @param {string} email - Correo electrónico del usuario.
 * @param {string} password - Contraseña del usuario.
 * @returns {Promise<Object>} - Respuesta de la API que contiene el token.
 */
export const login = async (email, password) => {
    try {
        const response = await apiClientU.post('/auth/login', {
            email,
            password,
        });

        // Suponiendo que el token viene en response.data.token
        const { token } = response.data;

        // Almacenar el token en localStorage
        localStorage.setItem('authToken', token);

        return response.data;
    } catch (error) {
        // Manejo de errores
        if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que está fuera del rango de 2xx
            throw new Error(error.response.data.message || 'Error en el inicio de sesión');
        } else if (error.request) {
            // La solicitud fue realizada pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Algo sucedió al configurar la solicitud que provocó un error
            throw new Error('Error al iniciar sesión');
        }
    }
};

/**
 * Cerrar sesión del usuario.
 * @returns {Promise<void>}
 */
export const logout = async () => {
    try {
        // Si tu API tiene un endpoint para cerrar sesión, puedes llamarlo aquí.
        // Por ejemplo:
        let response = await apiClient.post('/auth/logout');

        if(response.status === 200) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
        }

    } catch (error) {
        console.error('Error al cerrar sesión:', error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
        throw new Error('Error al cerrar sesión');
    }
};

/**
 * Verificar si el usuario está autenticado.
 * @returns {boolean} - Retorna true si el usuario está autenticado, de lo contrario false.
 */
export const isAuthenticated = () => {
    const token = localStorage.getItem('authToken');
    return !!token;
};

export const  recovery = async (email) => {
    try {
        const response = await apiClient.post('/auth/forgot-password', {
            email,
        });

        return response.data;
    } catch (error) {
        // Manejo de errores
        if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que está fuera del rango de 2xx
            throw new Error(error.response.data.message || 'Error en el inicio de sesión');
        } else if (error.request) {
            // La solicitud fue realizada pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Algo sucedió al configurar la solicitud que provocó un error
            throw new Error('Error al iniciar sesión');
        }
    }
}

export const verify = async (email,code) => {
    try {

        const response = await apiClient.post('/auth/verify-recovery-code', {
            email,
            recoveryCode: code
        });

        return response.data;
    } catch (error) {
        // Manejo de errores
        if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que está fuera del rango de 2xx
            throw new Error(error.response.data.message || 'Error en el inicio de sesión');
        } else if (error.request) {
            // La solicitud fue realizada pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Algo sucedió al configurar la solicitud que provocó un error
            throw new Error('Error desconocido, intente de nuevo');
        }
    }
}

export const reset = async (email, code, password) => {
    try {
        const response = await apiClient.post('/auth/change-password', {
            email,
            recoveryCode: code,
            password
        });

        return response.data;
    } catch (error) {
        // Manejo de errores
        if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que está fuera del rango de 2xx
            throw new Error(error.response.data.message || 'Error en el inicio de sesión');
        } else if (error.request) {
            // La solicitud fue realizada pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Algo sucedió al configurar la solicitud que provocó un error
            throw new Error('Error desconocido, intente de nuevo');
        }
    }
}

/**
 * Obtener el token de autenticación.
 * @returns {string|null} - Retorna el token si existe, de lo contrario null.
 */
export const getToken = () => {
    return localStorage.getItem('authToken');
};

/**
 * Registrar un nuevo usuario.
 * @param name
 * @param email
 * @param phone
 * @param password
 * @param role
 * @returns {Promise<any>}
 */
export const register = async (name, email, phone, password, role='user') => {
    try {
        const response = await apiClient.post('/auth/register', {
            name,
            email,
            phone,
            password,
            role : role
        });

        // Suponiendo que el token viene en response.data.token
        const { token } = response.data;

        // Almacenar el token en localStorage
        localStorage.setItem('authToken', token);

        return response.data;
    } catch (error) {
        // Manejo de errores
        if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que está fuera del rango de 2xx
            throw new Error(error.response.data.message || 'Error en el registro');
        } else if (error.request) {
            // La solicitud fue realizada pero no se recibió respuesta
            throw new Error('No se recibió respuesta del servidor');
        } else {
            // Algo sucedió al configurar la solicitud que provocó un error
            throw new Error('Error al registrar usuario');
        }
    }
}
